import React, { Component } from "react"
import { Link } from "gatsby"
import logo from "../../images/hrs-logo.png"

class Footer extends Component {
  render() {
    let currentYear = new Date().getFullYear()
    return (
      <footer className="footer-area">
        <div className="divider"></div>

        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <Link to="/">
                  <img src={logo} alt="HRS Systems Logo" className="logo" />
                </Link>
                <p>Hydraulic calculations you can trust.</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <h3>Company</h3>

                <ul className="services-list">
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/pricing">Our Pricing</Link>
                  </li>
                  <li>
                    <Link to="/blog">Latest News</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <h3>Support</h3>

                <ul className="support-list">
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <h3>Connect With Us</h3>

                <ul className="footer-contact-info">
                  <li>
                    Email:{" "}
                    <span>
                      <a href={"mailto:hass@hrssystems.com"}>
                        hass@hrssystems.com
                      </a>
                    </span>
                  </li>
                  <li>
                    Phone:{" "}
                    <span>
                      <a href={"tel:+1931-659-9760"}>+1 (931) 659-9760</a>
                    </span>
                  </li>
                </ul>
                <ul className="social">
                  <li>
                    <a href="https://www.facebook.com/hrssystems/">
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCofSqjMfCpXchWmJL59QtxA">
                      <i className="bx bxl-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/hrssystems/">
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="copyright-area">
            <p>Copyright {currentYear} HRS Systems, Inc.</p>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
